import React from 'react';
import { isBrowser, isMobile } from 'react-device-detect';
import { Link } from 'react-router-dom';
import { Autoplay, EffectFade, Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import { AssistirMaisTardeBotao } from 'Component/AssistirMaisTarde';
import BotaoLink from 'Component/BotaoLink';
import { CategoriaCartao } from 'Component/Categoria';
import { CursoCartao } from 'Component/Curso';
import Icone from 'Component/Icone';
import Curso from 'Interface/Cursos';
import {
  useRecuperarAssistirMaisTardeQuery,
  useRecuperarCategoriasQuery,
  useRecuperarCursosQuery,
} from 'Service';

const Home = (): React.ReactElement => {
  const { data: { assistir_mais_tarde } = {} } =
    useRecuperarAssistirMaisTardeQuery({
      contain: ['Cursos.Categorias'],
    });
  const { data: { cursos } = {} } = useRecuperarCursosQuery({
    contain: ['Categorias'],
    sort: 'Cursos.criado',
    direction: 'desc',
    limit: 15,
  });
  const { data: { cursos: cursosDeEducacao } = {} } = useRecuperarCursosQuery({
    finder: 'sortWithPriority',
    contain: ['Categorias'],
    options: { categoria_id: 3 },
    sort: 'Cursos.criado',
    direction: 'desc',
    limit: 15,
  });
  const { data: { cursos: cursosDeGestao } = {} } = useRecuperarCursosQuery({
    finder: 'sortWithPriority',
    contain: ['Categorias'],
    options: { categoria_id: 5 },
    sort: 'Cursos.criado',
    direction: 'desc',
    limit: 15,
  });
  const { data: { cursos: cursosDeTecnologia } = {} } = useRecuperarCursosQuery(
    {
      finder: 'sortWithPriority',
      contain: ['Categorias'],
      options: { categoria_id: 8 },
      sort: 'Cursos.criado',
      direction: 'desc',
      limit: 15,
    }
  );
  const { data: { cursos: destaques } = {} } = useRecuperarCursosQuery({
    contain: ['Matricula', 'MaisTarde'],
    options: { destaque: 1 },
  });
  const { data: { categorias } = {} } = useRecuperarCategoriasQuery();

  return (
    <div className="animate__animated animate__fadeIn">
      <div className="hf-700 hf-sm-600" style={{ marginTop: '-130px' }}>
        <Swiper
          effect="fade"
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
          modules={[EffectFade, Autoplay]}
        >
          {destaques?.map((curso) => (
            <SwiperSlide key={`${curso.id}-${curso.modificado}`}>
              <div
                className="hf-700 hf-sm-600 d-flex align-items-end pb-5"
                style={{
                  backgroundImage: `linear-gradient(0deg, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0.5) 100%), url(${curso.imagem})`,
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: 'center',
                  backgroundSize: 'cover',
                }}
              >
                <div className="px-4 px-sm-5 mt-5">
                  <Link
                    to={`/estudar/curso/${curso.slug}`}
                    className="text-decoration-none"
                  >
                    <h1 className="display-3 text-white">{curso.nome}</h1>
                  </Link>
                  <p className="lead text-muted col-sm-6">
                    {curso.descricao?.cortar(isBrowser ? 230 : 130)}
                  </p>
                  <BotaoLink
                    lg
                    tema="secondary"
                    icone="play-circle"
                    to={
                      curso?.matricula?.proxima_aula_id
                        ? `/estudar/curso/${curso.slug}/aula/${curso.matricula.proxima_aula_id}`
                        : `/estudar/curso/${curso.slug}`
                    }
                  >
                    Assistir agora
                  </BotaoLink>
                  <AssistirMaisTardeBotao
                    className="ms-sm-3 mt-2 mt-sm-0"
                    cursoId={curso.id}
                    dados={curso.mais_tarde}
                  />
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      {assistir_mais_tarde?.length ? (
        <div className="mb-5">
          <h1 className="fw-lighter text-muted mx-3 ms-4 ms-sm-5 mb-4">
            <Icone nome="clock-history" className="me-3 text-primary" />
            Para assistir mais tarde
          </h1>
          <Swiper
            slidesPerView="auto"
            centeredSlides={false}
            spaceBetween={15}
            grabCursor={true}
          >
            {assistir_mais_tarde?.map((assistir, indice) => (
              <SwiperSlide
                key={`${assistir.id}-${assistir.criado}`}
                style={{ width: '300px' }}
                className={!indice ? 'ms-4 ms-sm-5' : ''}
              >
                <CursoCartao dados={assistir.curso as Curso} />
              </SwiperSlide>
            ))}
            <SwiperSlide style={{ width: '300px' }}>
              <Link
                className="bg-dark rounded-3 d-flex flex-column justify-content-center align-items-center hf-200 text-decoration-none me-3"
                to="/estudar/assistir-mais-tarde"
              >
                <Icone nome="plus-circle" className="fs-1 text-secondary" />
                <p className="text-white mb-0">Ver lista completa</p>
              </Link>
            </SwiperSlide>
          </Swiper>
        </div>
      ) : null}
      <div className="mb-5">
        <h1 className="fw-lighter text-muted mx-3 ms-4 ms-sm-5 mb-4">
          Novos cursos
        </h1>
        <Swiper
          slidesPerView="auto"
          centeredSlides={false}
          spaceBetween={15}
          grabCursor={true}
          navigation={isMobile ? false : true}
          modules={[Navigation]}
        >
          {cursos?.map((curso, indice) => (
            <SwiperSlide
              key={`${curso.id}-${curso.modificado}`}
              style={{ width: '300px' }}
              className={
                !indice
                  ? 'ms-4 ms-sm-5'
                  : indice + 1 == cursos.length
                  ? 'me-3'
                  : ''
              }
            >
              <CursoCartao dados={curso} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      <div className="mb-5">
        <h1 className="fw-lighter text-muted mx-3 ms-4 ms-sm-5 mb-4">
          Cursos em Educação
        </h1>
        <Swiper
          slidesPerView="auto"
          centeredSlides={false}
          spaceBetween={15}
          grabCursor={true}
          navigation={isMobile ? false : true}
          modules={[Navigation]}
        >
          {cursosDeEducacao?.map((curso, indice) => (
            <SwiperSlide
              key={`${curso.id}-${curso.modificado}`}
              style={{ width: '300px' }}
              className={!indice ? 'ms-4 ms-sm-5' : ''}
            >
              <CursoCartao dados={curso} />
            </SwiperSlide>
          ))}
          <SwiperSlide style={{ width: '300px' }}>
            <Link
              className="bg-dark rounded-3 d-flex flex-column justify-content-center align-items-center hf-200 text-decoration-none me-3"
              to="/estudar/categoria/educacao"
            >
              <Icone nome="plus-circle" className="fs-1 text-secondary" />
              <p className="text-white mb-0">Ver lista completa</p>
            </Link>
          </SwiperSlide>
        </Swiper>
      </div>
      <div className="mb-5">
        <h1 className="fw-lighter text-muted mx-3 ms-4 ms-sm-5 mb-4">
          Cursos em Gestão
        </h1>
        <Swiper
          slidesPerView="auto"
          centeredSlides={false}
          spaceBetween={15}
          grabCursor={true}
          navigation={isMobile ? false : true}
          modules={[Navigation]}
        >
          {cursosDeGestao?.map((curso, indice) => (
            <SwiperSlide
              key={`${curso.id}-${curso.modificado}`}
              style={{ width: '300px' }}
              className={!indice ? 'ms-4 ms-sm-5' : ''}
            >
              <CursoCartao dados={curso} />
            </SwiperSlide>
          ))}
          <SwiperSlide style={{ width: '300px' }}>
            <Link
              className="bg-dark rounded-3 d-flex flex-column justify-content-center align-items-center hf-200 text-decoration-none me-3"
              to="/estudar/categoria/gestao"
            >
              <Icone nome="plus-circle" className="fs-1 text-secondary" />
              <p className="text-white mb-0">Ver lista completa</p>
            </Link>
          </SwiperSlide>
        </Swiper>
      </div>
      <div className="mb-5">
        <h1 className="fw-lighter text-muted mx-3 ms-4 ms-sm-5 mb-4">
          Cursos em Tecnologia
        </h1>
        <Swiper
          slidesPerView="auto"
          centeredSlides={false}
          spaceBetween={15}
          grabCursor={true}
          navigation={isMobile ? false : true}
          modules={[Navigation]}
        >
          {cursosDeTecnologia?.map((curso, indice) => (
            <SwiperSlide
              key={`${curso.id}-${curso.modificado}`}
              style={{ width: '300px' }}
              className={!indice ? 'ms-4 ms-sm-5' : ''}
            >
              <CursoCartao dados={curso} />
            </SwiperSlide>
          ))}
          <SwiperSlide style={{ width: '300px' }}>
            <Link
              className="bg-dark rounded-3 d-flex flex-column justify-content-center align-items-center hf-200 text-decoration-none me3"
              to="/estudar/categoria/tecnologia"
            >
              <Icone nome="plus-circle" className="fs-1 text-secondary" />
              <p className="text-white mb-0">Ver lista completa</p>
            </Link>
          </SwiperSlide>
        </Swiper>
      </div>
      <div className="mb-5">
        <h1 className="fw-lighter text-muted mx-3 ms-4 ms-sm-5 mb-4">
          <Icone nome="star-fill" className="me-3 text-secondary" />E muito mais
          para explorar...
        </h1>
        <Swiper
          slidesPerView="auto"
          centeredSlides={false}
          spaceBetween={15}
          grabCursor={true}
          navigation={isMobile ? false : true}
          modules={[Navigation]}
        >
          {categorias?.map((categoria, indice) => (
            <SwiperSlide
              key={`${categoria.id}-${categoria.modificado}`}
              style={{ width: '300px' }}
              className={!indice ? 'ms-4 ms-sm-5' : ''}
            >
              <CategoriaCartao dados={categoria} />
            </SwiperSlide>
          ))}
          <SwiperSlide style={{ width: '300px' }}>
            <Link
              className="bg-dark rounded-3 d-flex flex-column justify-content-center align-items-center hf-200 text-decoration-none me-3"
              to="/estudar/categorias"
            >
              <Icone nome="plus-circle" className="fs-1 text-secondary" />
              <p className="text-white mb-0">Ver lista completa</p>
            </Link>
          </SwiperSlide>
        </Swiper>
      </div>
    </div>
  );
};

export default Home;
